import { useNavigate, useLocation } from 'react-router-dom';
import { chatsIcon, homeIcon, createIcon } from '../../assets/icons';
import { FiLogIn, FiUser } from 'react-icons/fi';
import { useAuth } from '../../context/AuthContext';
import styles from './NavBottomBar.module.css';

interface NavBottomBarProps {
  // No props for now, but good practice to define the interface
}

interface User {
  username: string;
  icon?: string;
}

const NavBottomBar: React.FC<NavBottomBarProps> = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  const { isLoggedIn, user, isLoading } = useAuth();

  // Function to handle profile click
  const handleProfileClick = (): void => {
    if (isLoggedIn && user) {
      navigate(`/users/${user.username}`);
    } else {
      navigate('/login');
    }
  };

  return (
    <nav className={styles.bottomNav}>
      <button 
        className={`${styles.navItem} ${currentPath === '/explore' ? styles.selected : ''}`}
        onClick={() => navigate('/explore')}
        aria-label="Home"
        type="button"
      >
        <img src={homeIcon} alt="Home" className={styles.homeIcon} />
      </button>
      
      <button 
        className={`${styles.navItem} ${currentPath === '/chats' ? styles.selected : ''}`}
        onClick={() => navigate('/chats')}
        aria-label="Chats"
        type="button"
      >
        <img src={chatsIcon} alt="Chats" className={styles.chatsIcon} />
      </button>
      
      <button 
        className={`${styles.navItem} ${currentPath === '/create' || currentPath === '/create-character' || currentPath === '/create-scenario' ? styles.selected : ''}`}
        onClick={() => navigate('/create')}
        aria-label="Create"
        type="button"
      >
        <img src={createIcon} alt="Create" />
      </button>
      
      <button 
        className={`${styles.navItem} ${currentPath.startsWith('/users/') ? styles.selected : ''}`}
        onClick={handleProfileClick}
        aria-label={isLoggedIn ? "Profile" : "Login"}
        type="button"
      >
        {!isLoading && (
          isLoggedIn ? (
            user?.icon ? (
              <img 
                src={user.icon} 
                alt="Profile" 
                className={styles.profileIcon}
              />
            ) : (
              <FiUser size={24} className={styles.profileIconSvg} />
            )
          ) : (
            <FiLogIn size={24} />
          )
        )}
      </button>
    </nav>
  );
};

export default NavBottomBar; 